import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=0f113b6d"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f113b6d')) {
      api.createRecord('0f113b6d', component.options)
    } else {
      api.reload('0f113b6d', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=0f113b6d", function () {
      api.rerender('0f113b6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/quotations/Page.vue"
export default component.exports